import React, { createContext, useContext, useState } from 'react';

const TranslationContext = createContext();

export const useTranslation = () => {
    return useContext(TranslationContext);
};

export const TranslationProvider = ({ children }) => {
    const [translations, setTranslations] = useState({});
    const [isTranslationsLoaded, setIsTranslationsLoaded] = useState(false);

    const setTranslationsExternal = (newTranslations) => {
        setTranslations(newTranslations || {});
        setIsTranslationsLoaded(true);
    };

    // Keep prior translations visible while refreshing so nav labels do not flash empty.
    const beginTranslationsLoading = () => {};

    const completeTranslationsLoading = () => {
        setIsTranslationsLoaded(true);
    };

    const clearTranslations = () => {
        setTranslations({});
        setIsTranslationsLoaded(true);
    };

    return (
        <TranslationContext.Provider value={{ translations, setTranslations: setTranslationsExternal, beginTranslationsLoading, completeTranslationsLoading, clearTranslations, isTranslationsLoaded }}>
            {children}
        </TranslationContext.Provider>
    );
};
